import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Row, Col, ButtonToolbar, Button, Spinner } from "reactstrap";
import { renderField } from "../../../../utils/renderfield";
import renderDatePickerField from "../../../../shared/components/form/DatePicker";
import { validateCardStatementSearch } from "./validateSearch";
import AccessControl from "../../../../shared/components/AccessControl";
import { permissionsConstants } from "../../../../constants/permissions.constants";
import IssuersDropDown from "../../../Issuers/IssuersDropDown";

let CardStatementSearchForm = ({ handleSubmit, reset, pristine, invalid, startDate, endDate, loading,hideCardNumber }) => {
    return (
        <form className="form" onSubmit={handleSubmit}>
            <Row>
                <AccessControl allowedPermissions={[permissionsConstants.FETCH_ISSUER_CONFIGS]} renderNoAccess={() => ""}>
                    <Col lg="3">
                        <IssuersDropDown required id="issuer" label="Select Issuer" />
                    </Col>
                </AccessControl>
             {   !hideCardNumber &&(<Col lg="3">
                    <div className="form__form-group">
                        <span className="form__form-group-label required">Card Number</span>
                        <div className="form__form-group-field">
                            <Field id="cardPan" name="cardPan" component={renderField} type="text" placeholder="Card number" />
                        </div>
                    </div>
                </Col>)}
            </Row>
            <Row>
                <Col lg="3">
                    <div className="form__form-group">
                        <span className="form__form-group-label required">Start Date</span>
                        <div className="form__form-group-field">
                            <Field id="startDate" name="startDate" dateFormat="dd/MM/yyyy" maxDate={endDate || new Date()} component={renderDatePickerField} placeholder="Start Date" />
                        </div>
                    </div>
                </Col>
                <Col lg="3">
                    <div className="form__form-group">
                        <span className="form__form-group-label required">End Date</span>
                        <div className="form__form-group-field">
                            <Field id="endDate" name="endDate" dateFormat="dd/MM/yyyy" maxDate={new Date()} minDate={startDate} component={renderDatePickerField} placeholder="End Date" />
                        </div>
                    </div>
                </Col>
                <Col lg="3">
                    <ButtonToolbar className="mt-4 form__button-toolbar">
                        <Button color="primary" type="submit" id="btn-submit-cardStatement" disabled={loading || invalid}>
                            {loading ? (
                                <span>
                                    <Spinner size="sm" color="default" />{" "}
                                </span>
                            ) : null}
                            Search
                        </Button>
                        <Button type="button" id="btn-reset-cardStatement" onClick={reset} disabled={pristine || loading}>
                        Reset
                        </Button>
                    </ButtonToolbar>
                </Col>
            </Row>
        </form>
    );
};

CardStatementSearchForm = reduxForm({
    form: "transaction_report_search",
    enableReinitialize: true,
    validate: validateCardStatementSearch,
})(CardStatementSearchForm);

const selector = formValueSelector("transaction_report_search");
CardStatementSearchForm = connect((state) => {
    return {
        startDate: selector(state, "startDate"),
        endDate: selector(state, "endDate"),
    };
})(CardStatementSearchForm);

export default CardStatementSearchForm;
